// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1a3_3","footer":"ModalError_footer__3Rd9V"};